import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'

interface IProps {
  disabled: boolean
}

const ProductControl: FC<IProps> = ({ disabled }) => {
  const { control } = useFormContext<IKlantGroepModel>()
  const products = [
    { value: 'B', name: 'Bloemen' },
    { value: 'P', name: 'Planten' },
  ]

  return (
    <Controller
      control={control}
      name='productType'
      render={({ field }) => {
        const isProductSelected = (productValue: string): boolean => {
          if (field.value === 'A') return true
          return field.value?.includes(productValue) ?? false
        }

        const allSelected = field.value === 'A'

        const toggleProduct = (productValue: string) => {
          if (field.value === 'A') {
            const remaining = products
              .filter(p => p.value !== productValue)
              .map(p => p.value)
              .join(',')
            field.onChange(remaining)
          } else {
            const current = field.value
              ? field.value.split(',').filter(v => v !== '')
              : []

            if (current.includes(productValue)) {
              const updated = current.filter(v => v !== productValue).join(',')
              field.onChange(updated)
            } else {
              const updated = [...current, productValue]
              if (updated.length === products.length) {
                field.onChange('A')
              } else {
                field.onChange(updated.join(','))
              }
            }
          }
        }

        const toggleAll = () => {
          if (allSelected) {
            field.onChange('')
          } else {
            field.onChange('A')
          }
        }

        return (
          <div className='row'>
            <div className='col-10'>
              {products.map(product => (
                <div key={product.value}>
                  <input
                    type='checkbox'
                    id={`product-${product.value}`}
                    checked={isProductSelected(product.value)}
                    disabled={disabled}
                    onChange={() => toggleProduct(product.value)}
                  />
                  <label htmlFor={`product-${product.value}`} className='ml-1'>
                    {product.name} ({product.value})
                  </label>
                </div>
              ))}
            </div>

            <div
              className='col-2'
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <label htmlFor='product-all'>alle</label>
              <input
                type='checkbox'
                id='product-all'
                checked={allSelected}
                disabled={disabled}
                onChange={toggleAll}
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default ProductControl
